import { useState } from "react";
import {
  Modal,
  Button,
  Form as BSForm,
  CloseButton,
  Row,
  Col,
} from "react-bootstrap";

import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
// import axios from "axios";
import ImageUploaderWithPreview from "./ImageUploaderWithPreview";

import ProductCard from "../../User/ProductCard";
import API from "../../api/api";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
function ProductsModel({
  show,
  handleClose,
  payload,
  setPayload,
  getAllData,
  hostname,
}) {

   const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"], // 👈 enable image
    ],
  };
  // console.log(payload);

  const [loading, setIsLoading] = useState(false);

  const createProduct = async (values) => {
    try {
      setIsLoading(true);
      const formData = new FormData();

      // Append text fields
      formData.append("title", values.title);
      formData.append("brand", values.brand);
      formData.append("price", values.price);
      formData.append("description", values.description);
      formData.append("availableItems", values.availableItems);
      formData.append("originalPrice", values.originalPrice);
      formData.append("packSize", values.packSize);
      formData.append("rating", values.rating);
      formData.append("isNewItem", values.isNewItem === "new" ? true : false);
      formData.append("status", values.status);
      formData.append("order", values.order);

      // Append image
      if (values.imageFile) {
        formData.append("imageFile", values.imageFile);
      }

      // for (let [key, value] of formData.entries()) {
      //   console.log(key, value);
      // }

      // return;
      // Send request
      const response = await API.post(
        `${hostname}/api/products/create-product`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response.data);
      setIsLoading(false);

      getAllData();
      handleClose();
      toast.warning("Product Added.", { theme: "colored" });
      setPayload({});
      return true;
    } catch (err) {
      console.log(err);
      if ("response" in err)
        toast.error(err.response.data.error, { theme: "colored" });
      else toast.error("something went wrong!", { theme: "colored" });
      setIsLoading(false);
      return false;
    }
  };

  const validateImageFile = (file) => {
    // if (!file) return "Image is required";

    const maxSize = 2 * 1024 * 1024;
    const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];

    if (file && file.size > maxSize) return "File must be less than 2MB";
    if (file && !allowedTypes.includes(file.type))
      return "Only JPG, PNG, WEBP allowed";

    return null; // ✅ Valid
  };

  const updateProduct = async (values) => {
    try {
      setIsLoading(true);

      const formData = new FormData();

      // Append text fields
      formData.append("title", values.title);
      formData.append("brand", values.brand);
      formData.append("price", values.price);
      formData.append("description", values.description);
      formData.append("availableItems", values.availableItems);
      formData.append("originalPrice", values.originalPrice);
      formData.append("packSize", values.packSize);
      formData.append("rating", values.rating);
      formData.append("isNewItem", values.isNewItem === "new" ? true : false);
      formData.append("status", values.status);
      formData.append("order", values.order);

      formData.append("product_id", payload._id);

      // validate img
      const imageError = validateImageFile(values.imageFile);

      if (imageError) {
        // Show error toast or alert
        console.log(imageError);

        toast.error(imageError); // If using react-toastify
        return;
      }

      // Append image
      if (values.imageFile) {
        formData.append("imageFile", values.imageFile);
      }

      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      // return;
      // Send request
      const response = await API.post(
        `${hostname}/api/products/update-product`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response.data);
      setIsLoading(false);

      getAllData();
      handleClose();
      toast.warning("Product Updated.", { theme: "colored" });
      setPayload({});
      return true;
    } catch (err) {
      console.log(err);
      if ("response" in err)
        toast.error(err.response.data.error, { theme: "colored" });
      else toast.error("something went wrong!", { theme: "colored" });
      setIsLoading(false);
      return false;
    }
  };

  const deleteProduct = () => {
    setIsLoading(true);

    API.post(`${hostname}/api/products/delete-product`, {
      product_id: payload?._id,
    })
      .then((res) => {
        console.log(res.data);
        setIsLoading(false);

        handleClose();
        getAllData();
        toast.warning("Product deleted.", { theme: "colored" });
        setPayload({});
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);

        // getAllData();
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size={payload.loadType === "View Product" ? "lg " : "lg"}
    >
      <Modal.Header>
        <Modal.Title>{payload.loadType}</Modal.Title>
        <CloseButton onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        {payload.loadType === "Add Product" && (
          <Formik
            initialValues={{
              title: "",
              brand: "",
              description: "",
              availableItems: 0,
              price: "",
              originalPrice: "",
              packSize: "",
              imageFile: null,
              rating: 3,
              isNewItem: "new",
              status: "inactive",
              order: 0,
            }}
            validationSchema={Yup.object().shape({
              title: Yup.string().required("Title is required"),
              brand: Yup.string().required("Brand is required"),
              description: Yup.string().required("Description is required"),
              availableItems: Yup.number().required("Items required").min(0),
              price: Yup.number().required("Price is required").min(0),
              originalPrice: Yup.number().min(0),
              packSize: Yup.string().required("Pack size is required"),
              imageFile: Yup.mixed()
                .required("Image is required")
                .test(
                  "fileSize",
                  "File size must be less than 2MB",
                  (value) => {
                    return value && value.size <= 2 * 1024 * 1024; // 2MB
                  }
                )
                .test("fileType", "Only JPG, PNG allowed", (value) => {
                  return (
                    value &&
                    [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/webp",
                    ].includes(value.type)
                  );
                }),
              rating: Yup.number().min(1).max(5),
              order: Yup.number().min(0),
              status: Yup.string().oneOf(["active", "inactive"]),
              isNewItem: Yup.string().required("item selection is required!"),
            })}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              const ok = await createProduct(values);
              if (ok) resetForm();
              setSubmitting(false);
            }}
          >
            {({ values, handleChange, handleSubmit, setFieldValue }) => (
              <BSForm onSubmit={handleSubmit}>
                <Row className="mb-3 g-3">
                  <Col md={12}>
                    <BSForm.Group>
                      <BSForm.Label>Title</BSForm.Label>
                      <BSForm.Control
                        name="title"
                        value={values.title}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={4}>
                    <BSForm.Group>
                      <BSForm.Label>Price</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="price"
                        value={values.price}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="price"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>

                  <Col md={4}>
                    <BSForm.Group>
                      <BSForm.Label>Original Price</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="originalPrice"
                        value={values.originalPrice}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="originalPrice"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                  <Col md={4}>
                    <BSForm.Group>
                      <BSForm.Label>Total Items</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="availableItems"
                        value={values.availableItems}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="availableItems"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Brand</BSForm.Label>
                      <BSForm.Control
                        name="brand"
                        value={values.brand}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="brand"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Pack Size</BSForm.Label>
                      <BSForm.Control
                        name="packSize"
                        value={values.packSize}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="packSize"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Rating</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="rating"
                        value={values.rating}
                        onChange={handleChange}
                        min={1}
                        max={5}
                      />
                      <ErrorMessage
                        name="rating"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>

                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Order</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="order"
                        value={values.order}
                        onChange={handleChange}
                        min={0}
                      />
                      <ErrorMessage
                        name="order"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Status</BSForm.Label>
                      <BSForm.Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                      >
                        <option value="inactive">Inactive</option>
                        <option value="active">Active</option>
                      </BSForm.Select>
                      <ErrorMessage
                        name="status"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>

                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Mark As New</BSForm.Label>
                      <BSForm.Select
                        name="isNewItem"
                        value={values.isNewItem}
                        onChange={handleChange}
                      >
                        <option value="new">New</option>
                        <option value="old">Old</option>
                      </BSForm.Select>
                      <ErrorMessage
                        name="isNewItem"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>
                <Row className="mb-3 g-3">
                  <Col md={12}>
                    <BSForm.Group>
                      <BSForm.Label>Description</BSForm.Label>
                      <BSForm.Control
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        as={"textarea"}
                        rows={3}
                      />

                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={12}>
                    <BSForm.Group>
                      <ImageUploaderWithPreview
                        onUpload={(file) => setFieldValue("imageFile", file)}
                      />
                      <ErrorMessage
                        name="imageFile"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <div className="text-end">
                  <Button type="submit" disabled={loading}>
                    {loading ? "Submitting..." : "Create Product"}
                  </Button>
                </div>
              </BSForm>
            )}
          </Formik>
        )}
        {payload.loadType === "View Product" && (
          <Row>
            <Col md={6}>
              <ProductCard product={payload} viewMode />
            </Col>
          </Row>
        )}
        {payload.loadType === "Update Product" && (
          <Formik
            initialValues={{
              title: payload.title || "",
              brand: payload.brand || "",
              description: payload.description || "",
              availableItems: payload.availableItems || 0,
              price: payload.price || "",
              originalPrice: payload.originalPrice || "",
              packSize: payload.packSize || "",
              imageFile: null,
              rating: payload.rating || "",
              isNewItem: payload.isNewItem ? "new" : "old",
              status: payload.status || "inactive",
              order: payload.order || "",
            }}
            validationSchema={Yup.object().shape({
              title: Yup.string().required("Title is required"),
              brand: Yup.string().required("Brand is required"),
              description: Yup.string().required("Description is required"),
              availableItems: Yup.number().required("Items required").min(0),
              price: Yup.number().required("Price is required").min(0),
              originalPrice: Yup.number().min(0),
              packSize: Yup.string().required("Pack size is required"),
              // imageFile: '',
              rating: Yup.number().min(1).max(5),
              order: Yup.number().min(0),
              status: Yup.string().oneOf(["active", "inactive"]),
              isNewItem: Yup.string().required("item selection is required!"),
            })}
            context={{ isEditMode: true }} // 👈 set to false for create mode
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              const ok = await updateProduct(values);
              if (ok) resetForm();
              setSubmitting(false);
            }}
          >
            {({ values, handleChange, handleSubmit, setFieldValue }) => (
              <BSForm onSubmit={handleSubmit}>
                <Row className="mb-3 g-3">
                  <Col md={12}>
                    <BSForm.Group>
                      <BSForm.Label>Title</BSForm.Label>
                      <BSForm.Control
                        name="title"
                        value={values.title}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={4}>
                    <BSForm.Group>
                      <BSForm.Label>Price</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="price"
                        value={values.price}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="price"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>

                  <Col md={4}>
                    <BSForm.Group>
                      <BSForm.Label>Original Price</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="originalPrice"
                        value={values.originalPrice}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="originalPrice"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                  <Col md={4}>
                    <BSForm.Group>
                      <BSForm.Label>Total Items</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="availableItems"
                        value={values.availableItems}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="availableItems"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Brand</BSForm.Label>
                      <BSForm.Control
                        name="brand"
                        value={values.brand}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="brand"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Pack Size</BSForm.Label>
                      <BSForm.Control
                        name="packSize"
                        value={values.packSize}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="packSize"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Rating</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="rating"
                        value={values.rating}
                        onChange={handleChange}
                        min={1}
                        max={5}
                      />
                      <ErrorMessage
                        name="rating"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>

                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Order</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name="order"
                        value={values.order}
                        onChange={handleChange}
                        min={0}
                      />
                      <ErrorMessage
                        name="order"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <Row className="mb-3 g-3">
                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Status</BSForm.Label>
                      <BSForm.Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                      >
                        <option value="inactive">Inactive</option>
                        <option value="active">Active</option>
                      </BSForm.Select>
                      <ErrorMessage
                        name="status"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>

                  <Col md={6}>
                    <BSForm.Group>
                      <BSForm.Label>Mark As New</BSForm.Label>
                      <BSForm.Select
                        name="isNewItem"
                        value={values.isNewItem}
                        onChange={handleChange}
                      >
                        <option value="new">New</option>
                        <option value="old">Old</option>
                      </BSForm.Select>
                      <ErrorMessage
                        name="isNewItem"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>
                <Row className="mb-3 g-3">
                  <Col md={12}>
                    <BSForm.Group>
                      <BSForm.Label>Description</BSForm.Label>
                      <ReactQuill
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                        theme="snow"
                        style={{ height: "300px", marginBottom: "40px" }} // 👈 change height here
                        modules={modules}
                      />
                      {/* <BSForm.Control
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        as={"textarea"}
                        rows={3}
                      /> */}

                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>
                <Row className="mb-3 g-3">
                  <Col md={12}>
                    <BSForm.Group>
                      <ImageUploaderWithPreview
                        imageUrl={payload.imageUrl}
                        onUpload={(file) => setFieldValue("imageFile", file)}
                      />
                      <ErrorMessage
                        name="imageFile"
                        component="div"
                        className="text-danger fs--1"
                      />
                    </BSForm.Group>
                  </Col>
                </Row>

                <div className="text-end">
                  <Button type="submit" disabled={loading}>
                    {loading ? "Submitting..." : "Update Product"}
                  </Button>
                </div>
              </BSForm>
            )}
          </Formik>
        )}
        {payload.loadType === "Delete Product" && (
          <div>
            <>
              <p className="text-danger">
                Are you sure you want to delete this product ?
                <br />
                <span className="text-primary">"{payload.title}"</span>
              </p>
              <div className="text-end">
                <Button
                  variant="danger"
                  className="me-3 "
                  size="md"
                  onClick={deleteProduct}
                  style={{ width: 80 }}
                  disabled={loading}
                >
                  Yes
                </Button>
                <Button
                  variant="secondary"
                  size="md"
                  onClick={handleClose}
                  disabled={loading}
                  style={{ width: 80 }}
                >
                  No
                </Button>
              </div>
            </>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ProductsModel;
